<template>
    <div class="landing-page-event-details">
        <p class="title">
            {{ title }}
        </p>

        <p class="date">
            {{ displayDate }}
        </p>

        <p class="location">
            {{ location }}
        </p>

        <p class="description">
            {{ description }}
        </p>

        <b-button
            pill
            @click="handleClick"
            class="add-to-calendar-btn"
        >
            <i class="far fa-calendar-day mr-2" /> Add to Calendar
        </b-button>
    </div>
</template>

<script>
    import "./LandingPageEventDetails.scss";
    import LandingPageEventAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageEventAppResource";
    import Moment from "moment";

    export default {
        name: "LandingPageEventDetails",
        props: {
            event: {
                type: LandingPageEventAppResource,
                required: true,
            }
        },

        data() {
            return {
                timezone: Moment.tz.guess(),
            };
        },

        computed: {
            title() {
                return this.event.title;
            },

            date() {
                let date = this.event.timeStart ? this.event.timeStart : this.event.date;

                return Moment(date).tz(this.timezone).format('dddd, MMMM D');
            },

            timeStart() {
                return this.event.timeStart ? Moment(this.event.timeStart).tz(this.timezone).format('hh:mm A') : null;
            },

            timeEnd() {
                return this.event.timeEnd ? Moment(this.event.timeEnd).tz(this.timezone).format('hh:mm A') : null;
            },

            location() {
                return this.event.location;
            },

            description() {
                return this.event.description;
            },

            displayDate() {
                let displayDate = this.date;

                if (this.timeStart) {
                    displayDate += ` ${this.timeStart}`;
                }

                if (this.timeEnd) {
                    displayDate += ` - ${this.timeEnd}`;
                }

                return displayDate;
            },
        },

        methods: {
            async handleClick() {
                try {
                    let response = await this.event.addToCalendar();
                    let key = response.rawData.downloadKey;

                    window.open(window.env.MILESTONES_API_AUTH_URL + '/add-to-calendar/' + key, '_blank');
                } catch (error) {
                    console.warn(error);
                }
            }
        }
    };
</script>
